import React from 'react'
import LeftBar from '../Components/LeftBar'
import Dashnav from '../Components/Dashnav'
import MediaConsentNewComp from './MediaConsentNewComp'
import './dash.css'

function MediaConsentNew() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <MediaConsentNewComp />
      </div>
    </div>
  )
}

export default MediaConsentNew
